// The Halo "devices" illustration the mobile app shows on its no-cloud-licence
// screen (app/src/screens/Property/Property.js via HaloDevicesView): the boiler,
// the PRT dial, the halo wordmark. Geometry and colours are COPIED VERBATIM from
// the react-native-svg original in app/src/components/common/Icons.js
// (HaloDevices) so the web screen shows the real artwork rather than an
// approximation; attribute names are the React DOM camelCase spellings of the
// same SVG attributes. The hard-coded colours are the brand green, the near-black
// dial face and white — the same values as the --green-500 / --grey-950 tokens.
//
// This is a MANUAL COPY, like HaloLoginDevices: re-sync it if the app's changes.
// It is a bigger, different illustration from that one (408x389 against 218x147),
// which is why it is not shared with the sign-in screens.
//
// Decorative — the heading beside it carries the message — so it is hidden from
// assistive tech. Size is set by the caller's CSS (.non-connected__art svg); the
// width/height attributes only fix the aspect ratio.
export default function HaloDevices() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 408 389"
      width="408"
      height="389"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" fillRule="evenodd" transform="translate(1.05 1.5)">
        <g stroke="#95C11F" transform="translate(230.897)">
          <polygon
            strokeLinejoin="round"
            strokeWidth="2"
            points="0 6.303 143.709 0 175.005 10.511 175.005 249.514 143.709 272 0 255.734"
          />
          <line x1="143.709" x2="143.709" y2="272" strokeLinejoin="round" />
          <polyline
            strokeLinejoin="round"
            points="5.897 6.969 18.913 171.702 18.913 258.238"
          />
          <polyline
            strokeLinejoin="round"
            points="125.849 0 104.049 181.457 104.049 267.994"
          />
          <polyline points="143.709 179.851 104.049 185.49 18.913 179.851 0 172.429" />
        </g>
        <g transform="translate(0 103.783)">
          <rect
            width="211.184"
            height="143.817"
            stroke="#95C11F"
            strokeWidth="2"
          />
          <circle
            cx="134.027"
            cy="71.895"
            r="57.634"
            fill="#181818"
            stroke="#95C11F"
          />
          <path
            stroke="#95C11F"
            d="M11.3243073,62.026638 C15.5247017,63.6605107 21.03594,63.1356993 24.6410567,60.7426132 C29.3591486,57.6107557 33.7683219,53.3983586 33.272453,41.9861941 C34.3024669,41.9730233 35.3150316,41.7184353 36.22879,41.2428855 C37.186908,44.9762399 37.1425299,48.7511962 37.3308431,52.5303914 C37.5723945,57.37809 39.2243616,61.4940253 45.4084066,62.6853166 C48.6724208,63.3141007 52.3866072,62.7070296 55.2362675,60.9957396 C62.2255207,56.7985352 66.297229,50.9223837 67.2225053,44.0716979 C67.9353327,38.7939589 64.1732403,32.5084666 59.4039654,30.1385088 C54.3321916,27.6182309 48.4789728,25.9059354 38.8421155,32.0434334 C38.3170775,31.1574302 37.5915773,30.4069021 36.7238837,29.8521279 C39.4777962,27.1562445 42.7688141,25.3073817 45.9471366,23.2549625 C50.0245939,20.62192 52.763056,17.133313 50.7027229,11.1821165 C49.6152561,8.04101181 47.2324424,5.12795665 44.3255945,3.51571993 C37.1960811,-0.438546408 30.0713666,-1.0266856 23.6758603,1.59733786 C18.7487979,3.61888176 15.1864081,10.019741 15.5186021,15.3350257 C15.8718633,20.9873814 17.3155315,26.912466 27.4488197,32.1894278 C27.3020235,32.4463233 27.1727053,32.7128188 27.061744,32.9871034 C26.7955087,33.6687289 26.6447298,34.389958 26.6156032,35.1211531 C22.9018711,34.0844623 19.6538347,32.1578434 16.2857195,30.430775 C11.9667138,28.216116 7.57622439,27.5888193 3.45250456,32.3487175 C1.27595719,34.8610401 -0.055415536,38.3811634 0.00177116475,41.7046931 C0.142032306,49.8561618 3.19505923,56.3204111 8.66529114,60.5470725 C9.45545386,61.1576061 10.3549936,61.6495927 11.3243073,62.026638 Z M31.3327391,40.1049183 C30.0863467,39.6129057 29.0864552,38.6459161 28.5530303,37.4166772 C28.0196054,36.1874382 27.9963427,34.7966432 28.4883598,33.5502526 C29.5129154,30.9547922 32.4475112,29.6813143 35.0429781,30.7058535 C36.2893766,31.197853 37.2892789,32.1648328 37.8227167,33.3940672 C38.3561544,34.6233015 38.3794309,36.0140972 37.8874256,37.2604935 C37.395422,38.5068992 36.4284327,39.5068051 35.1991879,40.0402393 C33.9699431,40.5736736 32.579138,40.5969393 31.3327391,40.1049183 L31.3327391,40.1049183 Z"
            transform="translate(100.373 38.727)"
          />
          <rect
            width="6.681"
            height="8.414"
            x="12.841"
            y="144.659"
            fill="#95C11F"
          />
          <rect
            width="6.681"
            height="8.414"
            x="191.661"
            y="144.659"
            fill="#95C11F"
          />
          <polygon
            stroke="#95C11F"
            points="0 0 54.909 0 54.909 143.817 0 143.817"
          />
        </g>
        <g transform="translate(181.334 125.374)">
          <circle
            cx="49.563"
            cy="49.563"
            r="49.563"
            fill="#181818"
            stroke="#95C11F"
            strokeWidth="2"
          />
          <circle cx="49.563" cy="79.453" r="13.401" stroke="#95C11F" />
          <rect
            width="9.409"
            height="2.091"
            x="69.854"
            y="79.03"
            fill="#95C11F"
            rx="1.045"
          />
          <rect
            width="9.409"
            height="2.091"
            x="19.864"
            y="79.03"
            fill="#95C11F"
            rx="1.045"
          />
        </g>
        <path
          fill="#FFF"
          d="M278.274132,385.686282 L263.496857,385.686282 C247.917845,385.686282 235.243653,372.995211 235.243653,357.394257 L235.243653,318.823122 L237.211705,318.823122 L237.211705,357.394257 C237.211705,371.908225 249.003144,383.716542 263.496857,383.716542 L278.274132,383.716542 L278.274132,385.686282 Z"
        />
        <polygon
          fill="#FFF"
          points="18.382 347.685 20.372 347.685 20.372 318.841 18.382 318.841"
        />
        <path
          fill="#FFF"
          d="M18.3831341,385.670248 L20.349499,385.670248 L20.349499,366.475825 C20.349499,359.319269 26.1642006,353.497816 33.312317,353.497816 L53.2494012,353.492753 C61.4811282,353.492753 68.1785842,346.786857 68.1785842,338.543315 L68.1785842,318.82059 L66.2105313,318.82059 L66.2105313,338.543315 C66.2105313,345.699871 60.3958298,351.523012 53.2494012,351.523012 L33.312317,351.528075 C25.08059,351.528075 18.3831341,358.233971 18.3831341,366.475825 L18.3831341,385.670248 Z"
        />
        <polygon
          fill="#FFF"
          points="66.211 385.68 68.179 385.68 68.179 357.619 66.211 357.619"
        />
        <path
          fill="#FFF"
          d="M353.102505 319.762251C335.209428 319.762251 320.653264 334.33867 320.653264 352.257065 320.653264 370.173773 335.209428 384.751879 353.102505 384.751879 370.995583 384.751879 385.553435 370.173773 385.553435 352.257065 385.553435 334.33867 370.995583 319.762251 353.102505 319.762251M353.102505 386.72162C334.125818 386.72162 318.685211 371.260759 318.685211 352.257065 318.685211 333.253371 334.125818 317.79251 353.102505 317.79251 372.080881 317.79251 387.5198 333.253371 387.5198 352.257065 387.5198 371.260759 372.080881 386.72162 353.102505 386.72162M121.881953 385.674299 152.899883 320.362288 183.668009 385.674299 185.841982 385.674299 154.224859 318.557958C153.980118 318.043159 153.473758 317.722464 152.904947 317.720776L152.901571 317.720776C152.33276 317.720776 151.8264 318.039783 151.578283 318.557958L119.704604 385.674299 121.881953 385.674299Z"
        />
      </g>
    </svg>
  );
}
